@if (model && model.length > 0) {
  <div class="custom-tooltip">
    <div class="tooltip-header">
      {{ model[0].name }}
    </div>
    <div class="tooltip-series-list">
      @for (entry of entries; track entry) {
        <div class="tooltip-series-item">
          <span class="series-color" [style.backgroundColor]="entry.color"></span>
          <span class="me-1">{{ entry.series }}: </span>
          <span>{{ entry.value | number }}</span>
        </div>
      }
    </div>
    <h5>Events</h5>
    @if (entries[0] && getExtraData(entries[0]).length > 0) {
      <div class="tooltip-extra">
        <ul>
          @for (event of getExtraData(entries[0]); track event) {
            <li>{{ event }}</li>
          }
        </ul>
      </div>
    }
    @if (!entries[0] || !getExtraData(entries[0]).length) {
      <div>
        No events found
      </div>
    }
  </div>
}